export const truncateText = (inputText, truncateAt = 8) => {
  if (inputText.length < 9) {
    return inputText;
  }
  return `${inputText.substr(0, truncateAt)}...`;
}

export const isDNSCompliantString = (inputStr = '') => {
  if (!inputStr?.length) {
    return false;
  }
  const dnsRegex = /^(?![0-9]+$)(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$/g;
  return dnsRegex.test(inputStr);
}
